import React from 'react'
import { useSendFiatAvailable } from '../useSendFiatAvailable'
import SkeletonFiat from '~components/SendWidget/FiatFlow/SkeletonFiat'
import SkeletonCrypto from '~components/SendWidget/CryptoFlow/SkeletonCrypto'
import AssetTypeSelectorSkeleton from '~components/AssetTypeSelector/Skeleton'
import { SendReceiveInitialTab } from '~types'

interface Props {
    initialTab?: SendReceiveInitialTab
    type?: 'receive' | 'send'
}

function SendReceiveWidgetSkeleton({ initialTab, type = 'receive' }: Props) {
    const { isFiatAvailable, isFiatLoading } = useSendFiatAvailable()

    if (initialTab === 'fiat') {
        return <SkeletonFiat />
    }

    if (initialTab === 'crypto' || (!isFiatLoading && !isFiatAvailable)) {
        return <SkeletonCrypto type={type} />
    }

    return <AssetTypeSelectorSkeleton />
}

export default SendReceiveWidgetSkeleton
